import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Directive, Host, HostListener } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

@Directive({

  selector: 'mat-horizontal-stepper'
})
export class MatHorizontalStepperDirectiveDirective {

  constructor(private stepper: MatStepper) { }
  @HostListener('selectionChange', ['$event'])
  selectionChanged(selection: StepperSelectionEvent) {
    const stepId = this.stepper._getStepLabelId(selection.selectedIndex);
    const stepElement = document.getElementById(stepId);
    if (stepElement) {
      setTimeout(() => {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }, 150);
    }
  }
}
